module.exports = __webpack_public_path__ + "fonts/Nunito-BoldItalic.f5449ae0.ttf";